import { BankChronology, IBank } from "../slice/banksSlice/banksSlice";
import { api } from "./apiCore";

interface IArchiveBank {
  bank_id: number;
  is_enabled: boolean;
}

interface IBankRequest {
  title: string;
  id?: number;
  base_rate: string;
  excess: string;
}

interface IBankResponse {
  success: boolean;
  message: string;
  data: IBank[];
}

export interface BankChronologyRequest {
  title: string;
  base_rate: string;
  start_date: string;
  excess_tatBg: string;
  excess_agent: string;
  excess_bank: string;
  commission_tatBg_rate: string;
  commission_agent_rate: string;
}

export const banksApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // архивировать банк
    archiveBank: builder.mutation<IArchiveBank, IArchiveBank>({
      query: (value) => ({
        url: `/auth/bank/${value.bank_id}/enable`,
        method: "PATCH",
        body: {
          is_enabled: value.is_enabled,
        },
      }),
    }),
    // изменить банк
    editBank: builder.mutation<IBankResponse, IBankRequest>({
      query: (value) => ({
        url: `/auth/bank/${value.id}`,
        method: "PUT",
        body: {
          title: value.title,
          base_rate: value.base_rate,
          excess: value.excess,
        },
      }),
    }),
    // удалить банк
    deleteBank: builder.mutation<unknown, { id: number }>({
      query: (value) => ({
        url: `/auth/bank/${value.id}`,
        method: "DELETE",
      }),
    }),
    // добавить банк
    addBank: builder.mutation<IBank, IBankRequest>({
      query: (value) => ({
        url: `/auth/bank`,
        method: "POST",
        body: {
          title: value.title,
          base_rate: value.base_rate,
          excess: value.excess,
        },
      }),
      transformResponse: (response) => response.data,
    }),
    // добавить запись в хронологию банка
    addBankChronology: builder.mutation<
      BankChronology,
      { bank_id: number; bank_chronology: BankChronologyRequest }
    >({
      query: (value) => ({
        url: `/auth/bank/${value.bank_id}`,
        method: "PUT",
        body: value.bank_chronology,
      }),
      transformErrorResponse: (response) => {
        return response.data?.message;
      },
    }),
  }),
});

export const {
  useArchiveBankMutation,
  useEditBankMutation,
  useAddBankMutation,
  useAddBankChronologyMutation,
} = banksApi;
